import { Form } from 'formik';
import styled from 'styled-components';
import media from '../../../constants/media';
import { Column, Columns } from '../../base/grid';
import { A } from '../../base/typography';

export const Wrapper = styled(Form)``;

export const CountrySelectWrapper = styled.div``;

export const WeightAndDimensionWrapper = styled.div``;

export const CountrySelectColumns = styled(Columns)`
	align-items: stretch;
`;

export const ShipmentLocationFigure = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;

	svg {
		width: 60%;
		height: 60%;
	}
`;

export const ImgColumn = styled(Column)`
	${media.mobileOnly`
        display: none;
    `}
`;

export const ServicesWrapper = styled.div`
	margin: 6rem 0;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: end;

	> div {
		max-width: 50%;
	}

	${media.mobileOnly`
        flex-direction: column;
        > div {
            max-width: 100%;
            margin-bottom: 2rem;
        }
    `}
`;

export const PriceListWrapper = styled.div`
	${media.desktopSmall`
		margin: 6rem 0;
	`}
`;

export const PriceListLink = styled(A)`
	display: block;
	margin-bottom: 0.5rem;
	text-decoration: underline;
`;

export const IconWorldImg = styled.img``;

export const StyledColumn = styled(Column)`
	display: none;
	${media.desktopSmall`
        display: block;
    `}
`;
